"use client";
import { ark } from "../factory.js";
import { useProgressContext } from "./use-progress-context.js";
import { forwardRef } from "react";
import { mergeProps } from "@zag-js/react";
import { jsx } from "react/jsx-runtime";
//#region src/components/progress/progress-circle-range.tsx
var ProgressCircleRange = forwardRef((props, ref) => {
	const mergedProps = mergeProps(useProgressContext().getCircleRangeProps(), props);
	return /* @__PURE__ */ jsx(ark.circle, {
		ref,
		...mergedProps
	});
});
ProgressCircleRange.displayName = "ProgressCircleRange";
//#endregion
export { ProgressCircleRange };
